
  import { css } from 'lit';
  export const styles = css`[part~=attachment-icon]{--ig-size: 2}`;
  